<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    坂田站<br>
站点介绍<br>
坂田站位于布龙公路和坂雪岗大道交叉路口，沿布龙公路东西向跨路口布置。车站东侧为河背村；车站东北侧有扬马社区及坂田街道第一办公楼；车站西南侧为旭景佳园住宅区、绿怡居及富豪花园；车站西北为坂田医院。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:01	23:26	5号线	3分钟	5分25秒<br>
黄贝岭	06:14	23:55	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	23:26	5号线	4分钟	6分钟<br>
黄贝岭	06:03	23:55	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	00:26	5号线	4分钟	6分钟<br>
黄贝岭	06:03	00:55	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
布龙路南侧（西）、坂雪岗大道西侧（南）、富豪花园、珠江旭景佳园、十二橡树庄园、和磡村<br><br>
B出入口:<br>
河背村、禾塘光小区、布龙路南侧、坂雪岗大道东侧（南）、新河街、侨联西村、马安堂、马安堂社康中心<br><br>
C出入口:<br>
扬马小区、杨美村、坂田中心大厦、金州嘉丽园、扬美实验学校、布龙路北侧、坂雪岗大道东侧（北）、扬马社区、河背新村、扬马市场<br><br>
D出入口:<br>
坂田医院、坂田小学、坂雪岗大道西侧（北）、坂田社区、万港大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 富豪花园<br>
313、333、M198、M221、M300、M385、M481、M505、M568、M572、高峰专线37路、高峰专线31号、E8<br><br>
B出入口:<br>
公交站名： 坂田地铁站<br>
312、321、982、E22、E27、E7、M233、M300、M301、M385、M398、M415、M447、M521、M524、M572、高峰专线31号<br><br>
C出入口:<br>
公交站名： 扬马市场<br>
12、313、321、333、M233、M448、M481、M505、M523、M547、M568、高峰专线37路<br><br>
D出入口:<br>
公交站名： 坂田医院<br>
982、E7、M301、M398、M415、M447<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


